import { inject, Injectable } from '@angular/core';
import { ENDPOINTS, OnlineOnlyService } from '@evorait/pace-core';
import { ODataGetListFormModel } from '@evorait/pace-forms';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { getTestFormsListError, getTestFormsListSuccess } from '../../store/actions/authors.action';

@Injectable({
    providedIn: 'root',
})
export class TestFormService {
    private onlineOnlyService = inject(OnlineOnlyService);
    private store = inject(Store);

    public addTestFormsListToState(): Observable<ODataGetListFormModel[]> {
        return this.getTestFormList().pipe(
            tap((formList) => {
                this.store.dispatch(getTestFormsListSuccess({ formsList: formList }));
            }),
            catchError((error) => {
                this.store.dispatch(getTestFormsListError({ error }));
                return throwError(() => new Error(error));
            }),
        );
    }

    public getTestFormList(): Observable<ODataGetListFormModel[]> {
        const query = ENDPOINTS.GetTestFormListSet.toString();
        return this.onlineOnlyService.get(query) as Observable<ODataGetListFormModel[]>;
    }
}
